const LEAD_IN =
  'Bank revaluations and unrealised currency gains or losses may not be fully reflected in these figures. If the numbers look unexpected, please check '

export const REVALUATION_MISSING_MESSAGE = `${LEAD_IN}this company's Xero connection.`

// The backend flags the whole call, not a specific org, so a multi-org analysis points at all of them.
export const REVALUATION_MISSING_MESSAGE_CONSOLIDATED = `${LEAD_IN}the Xero connections for the companies in this analysis.`

export function revaluationMissingMessage(consolidated = false): string {
  return consolidated ? REVALUATION_MISSING_MESSAGE_CONSOLIDATED : REVALUATION_MISSING_MESSAGE
}
